// extracted by mini-css-extract-plugin
export default {"textContainer":"dataCaseStudy_textContainer__ip1Ob","overlay":"dataCaseStudy_overlay__wywdx","heading":"dataCaseStudy_heading__e+Bcn"};